import { HelpCircleOutlineIc } from '@dsch/dd-icons';

import Text from '../../../../../../components/ToolkitV2/Text/Text';

import * as Styled from './TextWithHelpIcon.styled';
import { TextProps } from '../../../../../../components/ToolkitV2/Text/Text.typed';

type TextWithHelpIconProps = {
  text: string;
  onClickIcon: () => void;
} & TextProps;

const TextWithHelpIcon = (props: TextWithHelpIconProps) => {
  const { text, onClickIcon, 'aria-label': ariaLabel, ...rest } = props;

  return (
    <Styled.TextAndIconContainer>
      <Text forwardedAs="span" size="M16" color="GREY_DARK" {...rest}>
        {text}
      </Text>
      <Styled.IconButton
        onClick={onClickIcon}
        type="button"
        aria-label={ariaLabel}
      >
        <HelpCircleOutlineIc height="16" width="16" />
      </Styled.IconButton>
    </Styled.TextAndIconContainer>
  );
};

export { TextWithHelpIcon };
